import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PublicPlaceResult {
  id: string;
  name: string;
  municipality: string | null;
  landskap: string | null;
  description_short: string | null;
}

/**
 * Search published places by name/municipality for the qualification flow.
 * Works for both authenticated and anonymous users (places with status='public'
 * are publicly readable via RLS).
 */
export function useSearchPublicPlaces(query: string) {
  return useQuery<PublicPlaceResult[]>({
    queryKey: ['public-places-search', query],
    enabled: query.trim().length >= 2,
    staleTime: 30_000,
    queryFn: async () => {
      const q = query.trim();
      const { data, error } = await supabase
        .from('places')
        .select('id, name, municipality, landskap, description_short')
        .eq('status', 'public')
        .or(`name.ilike.%${q}%,municipality.ilike.%${q}%,landskap.ilike.%${q}%`)
        .order('name')
        .limit(20);

      if (error) throw error;
      return (data ?? []) as PublicPlaceResult[];
    },
  });
}
